import React from "react";
import "./Flashcard.scss";
import { Callout, TextField } from "@wwnds/react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const Trans = (props) => {
  return (
    <TransitionGroup>
      <CSSTransition
        appear={true}
        exit={true}
        timeout={500}
        classNames={props.transition}
        unmountOnExit
      >
        {props.children}
      </CSSTransition>
    </TransitionGroup>
  );
};

class FlashCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      term: "term",
      input: "",
      transition: this.props.transition,
    };
    this.textFieldRef = React.createRef();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.flipped !== prevProps.flipped && !this.props.flipped) {
      this.setState({ input: "" });
    }
  }
  render() {
    return (
      <main className={"card"}>
        {!this.props.flipped && this.front()}
        {this.props.flipped && this.back()}{" "}
      </main>
    );
  }

  front = () => {
    return (
      <div
        className="front"
        key={
          this.props.definition + this.props.term + this.props.mode.toString()
        }
      >
        <span>
          <b className="identifier">
            {this.props.mode ? "DEFINITION" : "TERM"}
          </b>
          <Trans transition={this.props.transition}>
            <p
              className={
                this.props.mode
                  ? "by-term-identifier-content"
                  : "by-definition-identifier-content"
              }
              dangerouslySetInnerHTML={{
                __html: this.props.mode
                  ? this.props.definition
                  : this.props.term,
              }}
            ></p>
          </Trans>
        </span>

        <TextField
          style={{ minHeight: this.props.mode ? "58px" : "58px" }}
          multiline
          validateOnChange
          ref={this.textFieldRef}
          autoSize={true}
          className="student-input-content"
          onDOMChange={(e) => {
            let intHeight = parseInt(e.target.style.height.slice(0, -2));
            if (intHeight > 57) intHeight = intHeight + 20;
            intHeight = intHeight.toString() + "px";
            this.setState({ input: e.target.value, inputHeight: intHeight });
          }}
        >
          <span className="student-input-title">
            {this.props.mode ? "Your Term" : "Your Definition"}
          </span>
        </TextField>
      </div>
    );
  };

  back = () => {
    return (
      <div className="back">
        <b className="identifier">{this.props.mode ? "DEFINITION" : "TERM"}</b>
        <Trans transition={this.props.transition}>
          <p
            style={{ marginBottom: "12px", color: "var(--nds-navy-100)" }}
            dangerouslySetInnerHTML={{
              __html: this.props.mode ? this.props.definition : this.props.term,
            }}
          ></p>
        </Trans>

        <Callout
          title={this.props.mode ? "TERM" : "DEFINITION"}
          border="left"
          color="success"
          className="identifier-answer"
        >
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.mode ? this.props.term : this.props.definition,
            }}
          ></p>
        </Callout>
        {this.state.input && (
          <TextField
            multiline
            disabled
            className="student-input"
            value={this.state.input}
            style={{ height: this.state.inputHeight }}
          >
            <span>{this.props.mode ? "Your Term" : "Your Definition"}</span>
          </TextField>
        )}
      </div>
    );
  };
}

export default FlashCard;
